var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../../utilities/dom';
import { hideMenuProvider } from '../../utilities/picker.tools';
import styles from '../sds-date-picker.lit.scss';
import '../shared/calendar/sds-calendar.lit';
import stylesGlobal from '../shared/sds-datepicker-item/_sds-date-picker-base.lit.scss';
import '../shared/sds-datepicker-item/sds-datepicker-item.lit';
import './inner-year-picker/inner-year-picker.lit';
import { formatYear } from './year-picker-calculations';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-year-picker` is a web component designed for selecting a specific year.
 * It allows users to easily choose a year, making it ideal for scenarios such as
 * date selection in forms, event scheduling, and any context where year input is necessary.
 *
 * The component features customizable attributes, including options for placeholders,
 * selected years, hints, and error handling.
 *
 * ### Attributes
 * - `placeholder`: The placeholder text for the input field. Defaults to `'sds.year_picker.placeholder'`.
 * - `selected-year`: The currently selected year, represented as a number or `undefined`.
 * - `current-year`: The current year, represented as a number or `undefined`.
 * - `hint`: A hint to provide context for the selection. Defaults to an empty string.
 * - `disabled`: A boolean indicating if the picker is disabled. Defaults to `false`.
 * - `invalid`: A boolean indicating if the selection is invalid. Defaults to `false`.
 * - `error-message`: The error message to display if validation fails. Defaults to an empty string.
 *
 * @tag sds-year-picker
 */
let SdsYearPicker = (() => {
    var _SdsYearPicker_placeholder_accessor_storage, _SdsYearPicker_selectedYear_accessor_storage, _SdsYearPicker_currentYear_accessor_storage, _SdsYearPicker_hint_accessor_storage, _SdsYearPicker_disabled_accessor_storage, _SdsYearPicker_invalid_accessor_storage, _SdsYearPicker_errorMessage_accessor_storage, _SdsYearPicker__contextMenu_accessor_storage, _SdsYearPicker__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-year-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _selectedYear_decorators;
    let _selectedYear_initializers = [];
    let _selectedYear_extraInitializers = [];
    let _currentYear_decorators;
    let _currentYear_initializers = [];
    let _currentYear_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsYearPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsYearPicker_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.year_picker.placeholder'));
            _SdsYearPicker_selectedYear_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _selectedYear_initializers, void 0)));
            _SdsYearPicker_currentYear_accessor_storage.set(this, (__runInitializers(this, _selectedYear_extraInitializers), __runInitializers(this, _currentYear_initializers, void 0)));
            _SdsYearPicker_hint_accessor_storage.set(this, (__runInitializers(this, _currentYear_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsYearPicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsYearPicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsYearPicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsYearPicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsYearPicker__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsInnerYearPicker = __runInitializers(this, __inputDate_extraInitializers);
            this.stylesGlobal = stylesGlobal;
            this.hideMenu = hideMenuProvider(this);
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateSelectedYear();
                this.updatePageIndex();
            };
            this.handleYearPicked = (event) => {
                this.updateSelectedYear(event.detail.selectedYear);
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.setMapper();
                }
            };
        }
        /**
         * Sets the placeholder text for the year picker input field, providing a hint to users when no year is selected.
         * This attribute helps guide users to understand the expected input or purpose of the year selection.
         *
         * This placeholder text enhances accessibility and user experience by indicating
         * what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the year picker input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsYearPicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsYearPicker_placeholder_accessor_storage, value, "f"); }
        /**
         * Represents the currently selected year, reflected as a number.
         * This attribute allows users to specify which year is currently selected in the picker.
         * Setting this attribute updates the internal state of the component and reflects
         * the selected year accurately.
         *
         * @attr {number} selected-year - The currently selected year.
         */
        get selectedYear() { return __classPrivateFieldGet(this, _SdsYearPicker_selectedYear_accessor_storage, "f"); }
        set selectedYear(value) { __classPrivateFieldSet(this, _SdsYearPicker_selectedYear_accessor_storage, value, "f"); }
        /**
         * Represents the current year, reflected as a number.
         * This attribute provides context for the user, ensuring they can easily identify
         * the current year while making their selection.
         *
         * @attr {number} current-year - The current year.
         */
        get currentYear() { return __classPrivateFieldGet(this, _SdsYearPicker_currentYear_accessor_storage, "f"); }
        set currentYear(value) { __classPrivateFieldSet(this, _SdsYearPicker_currentYear_accessor_storage, value, "f"); }
        /**
         * Sets a hint for this year picker, providing additional context to users.
         * This attribute enhances user experience by clarifying the selection purpose.
         *
         * @attr {string} hint - A hint to provide context for the selection.
         */
        get hint() { return __classPrivateFieldGet(this, _SdsYearPicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsYearPicker_hint_accessor_storage, value, "f"); }
        /**
         * True if this year picker is disabled, preventing user interaction.
         * This attribute is useful for indicating when the picker should be non-functional.
         *
         * @attr {boolean} disabled - Indicates if the picker is disabled.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsYearPicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsYearPicker_disabled_accessor_storage, value, "f"); }
        /**
         * True if this year picker is invalid, often used for validation purposes.
         * This attribute indicates to users that the current selection is not acceptable.
         *
         * @attr {boolean} invalid - Indicates if the selection is invalid.
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsYearPicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsYearPicker_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this year picker, displayed when validation fails.
         * This attribute provides feedback to users, guiding them to correct their input.
         *
         * @attr {string} error-message - The error message to display if validation fails.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsYearPicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsYearPicker_errorMessage_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsYearPicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsYearPicker__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsYearPicker__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsYearPicker__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu id="context-menu">
                <sds-inner-year-picker
                    id="sds-inner-year-picker"
                    current-year="${this.currentYear}"
                    @sds.inner-year-picker.changed="${this.handleYearPicked}"
                    tabindex="0"
                >
                </sds-inner-year-picker>
            </sds-context-menu>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('selectedYear')) {
                this.setMapper();
                this.hideContextMenu();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('selectedYear')) {
                if (this.selectedYear) {
                    this.updateInput(this.selectedYear);
                }
                else {
                    this.updateInput();
                }
            }
        }
        async firstUpdated() {
            appendStylesToTheStyleRoot(this, 'sds-inner-year-picker', this.stylesGlobal.cssText);
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        initCmContentContainer() {
            var _a;
            const sdsInnerYearPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-inner-year-picker');
            if (sdsInnerYearPicker) {
                this._sdsInnerYearPicker = sdsInnerYearPicker;
            }
        }
        resetPage() {
            this.updatePageIndex();
        }
        updatePageIndex() {
            var _a, _b;
            if (this.selectedYear === undefined) {
                (_a = this._sdsInnerYearPicker) === null || _a === void 0 ? void 0 : _a.openPageInitialPage();
            }
            else {
                (_b = this._sdsInnerYearPicker) === null || _b === void 0 ? void 0 : _b.openPageFor(this.selectedYear);
            }
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        dispatchChange(value) {
            this.dispatchEvent(new CustomEvent(SdsYearPicker.YEAR_PICKER_CHANGE_EVENT, {
                detail: {
                    selectedYear: value,
                },
            }));
        }
        updateSelectedYear(year) {
            this.selectedYear = year;
            this.dispatchChange(year);
            this.setMapper();
        }
        setMapper() {
            var _a, _b;
            // to disconnect mapper from this picker
            const year = this.selectedYear;
            if (year !== undefined) {
                (_a = this._sdsInnerYearPicker) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(key => key === year ? 'selected' : 'none');
            }
            else {
                (_b = this._sdsInnerYearPicker) === null || _b === void 0 ? void 0 : _b.setYearStateMapper(() => 'none');
            }
        }
        updateInput(value) {
            this._inputDate.value = formatYear(value) || '';
        }
    };
    _SdsYearPicker_placeholder_accessor_storage = new WeakMap();
    _SdsYearPicker_selectedYear_accessor_storage = new WeakMap();
    _SdsYearPicker_currentYear_accessor_storage = new WeakMap();
    _SdsYearPicker_hint_accessor_storage = new WeakMap();
    _SdsYearPicker_disabled_accessor_storage = new WeakMap();
    _SdsYearPicker_invalid_accessor_storage = new WeakMap();
    _SdsYearPicker_errorMessage_accessor_storage = new WeakMap();
    _SdsYearPicker__contextMenu_accessor_storage = new WeakMap();
    _SdsYearPicker__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsYearPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _selectedYear_decorators = [property({ reflect: true, attribute: 'selected-year', type: Number })];
        _currentYear_decorators = [property({ reflect: true, attribute: 'current-year', type: Number })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __contextMenu_decorators = [query('#context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _selectedYear_decorators, { kind: "accessor", name: "selectedYear", static: false, private: false, access: { has: obj => "selectedYear" in obj, get: obj => obj.selectedYear, set: (obj, value) => { obj.selectedYear = value; } }, metadata: _metadata }, _selectedYear_initializers, _selectedYear_extraInitializers);
        __esDecorate(_classThis, null, _currentYear_decorators, { kind: "accessor", name: "currentYear", static: false, private: false, access: { has: obj => "currentYear" in obj, get: obj => obj.currentYear, set: (obj, value) => { obj.currentYear = value; } }, metadata: _metadata }, _currentYear_initializers, _currentYear_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsYearPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.YEAR_PICKER_CHANGE_EVENT = 'sds.year-picker.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsYearPicker = _classThis;
})();
export { SdsYearPicker };
